import 'Assets/Css/font-awesome.min.css';
import React from 'react';
import Icons from 'Helpers/Icons';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import './Icon.css';

const styles = () => ({
  root: {},
});

const Icon = ({
  className,
  width,
  height,
  icon,
  src,
}) => (
  <i
    className={classNames('Icon', className)}
    style={{
      backgroundImage: src ? `url(${src})` : `url(${Icons[icon]})`,
      minWidth: width,
      width,
      height,
    }}
  />
);

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  src: PropTypes.string,
};

Icon.defaultProps = {
  className: '',
  width: undefined,
  height: undefined,
  src: undefined,
  icon: undefined,
};

export default withStyles(styles)(Icon);
